import React, { useState, useRef } from 'react';
import classes from './UssdComponent.module.scss';
import { useNavigate } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

function UssdComponent({ ussdData }) {
  const navigate = useNavigate();
  const [activeVideo, setActiveVideo] = useState(null);
  const videoRef = useRef(null);

  const handlePlayClick = (index) => {
    setActiveVideo(index);
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.playbackRate = 1;
      }
    }, 100);
  };

  const closeVideo = () => {
    setActiveVideo(null);
  };

  return (
    <div>
      <Header />
      <div className={classes.ussdComponent}>
        <div className={classes.ussdBackImage}>
          <span className={classes.mainTitle}>SUPPORTED USSD GAMES LIST</span>
        </div>
        <div className="container">
          <div className={classes.infoUssdComponent}>
            <span className="titleBack" onClick={() => navigate('/')}>
              Back to Demo Homepage
            </span>

            <div className={classes.infoCont}>
              <div className={classes.gameVidoes}>
                {ussdData.map((data, index) => (
                  <div key={index}>
                    <div>
                      <div
                        className={`${classes.imageInside} ${classes[data.background]}`}
                        onClick={() => handlePlayClick(index)}
                      >
                        {data.image && (
                          <img
                            src={data.image}
                            alt={`Game ${index + 1}`}
                            className={classes.image}
                          />
                        )}
                        {activeVideo !== index && (
                          <div className={classes.playIcon}>
                            <div className={classes.arrowInside} />{' '}
                          </div>
                        )}
                      </div>
                      <span className={classes.imageText}>{data.text}</span>
                    </div>

                    {activeVideo === index && (
                      <div className={classes.overlay}>
                        <span
                          className={classes.exitStyle}
                          onClick={closeVideo}
                        >
                          x
                        </span>
                        <video
                          ref={videoRef}
                          controls
                          autoPlay
                          height="500"
                          width="100%"
                          className={classes.video}
                        >
                          <source type="video/mp4" src={data.videoUrl} />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer changeColor="white" iconsColor="black" />
    </div>
  );
}

export default UssdComponent;
